import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';



const styles = theme => ({
  container: {
    height: '100px',
    backgroundColor: '#fff',
    color: '#5f6368',
    display:'flex',
    margin:'0 40px',
    justifyContent:'flex-end',
    borderTop:'1px solid rgba(0,0,0,.12)'
  },
  footerBlock:{
   padding: '32px 0',
  },
  copyright:{
    paddingTop:'15px',
    fontSize: '14px',
  }
  
});


function Footer(props) {
  const { classes } = props;
    return (
      <footer className={classes.container}>
        <div className={classes.footerBlock}>
          <div className={classes.copyright}>Copyright 2018</div>
        </div>
      </footer>
    );
}


Footer.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(Footer);




// WEBPACK FOOTER //
// ./src/component/layouts/footer.js